import React from 'react';
import classNames from 'classnames';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { Box } from '../Box/Box';
import { Stars } from './Stars';
import styles from './StarRating.module.less'; // TODO: Fix bug where clicking on an SVG viewBox shows an animation but doesn't update with onClick

/**
 * Displays a visual rating of a product, including a NerdWallet-specific rating.
 * `StarRatingInput` allows users to interactively rate.
 */
export var StarRating = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var ariaLabel = props['aria-label'],
      className = props.className,
      label = props.label,
      _props$maxRating = props.maxRating,
      maxRating = _props$maxRating === void 0 ? 5 : _props$maxRating,
      _props$nerdwallet = props.nerdwallet,
      nerdwallet = _props$nerdwallet === void 0 ? false : _props$nerdwallet,
      _props$rating = props.rating,
      rating = _props$rating === void 0 ? 0 : _props$rating;
  useDeprecatedClassNameStylePropsWarning('StarRating', {
    className: className
  });
  return /*#__PURE__*/React.createElement(Box, {
    display: "inline-block",
    className: [styles.container, className],
    ref: ref
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.stars)
  }, label && /*#__PURE__*/React.createElement("span", {
    className: styles.legend
  }, label), /*#__PURE__*/React.createElement(Stars, {
    maxRating: maxRating,
    nerdwallet: nerdwallet,
    rating: rating // Assign role="img" so assistive technologies will
    // interpret this as an image and read the label
    // passed in below.
    ,
    role: "img",
    "aria-label": ariaLabel || "rated ".concat(rating, " out of ").concat(maxRating, " stars"),
    "data-currency": "StarRating"
  })));
});
StarRating.displayName = 'StarRating';